import { createBrowserRouter, Navigate, useParams } from "react-router";
import { RequireAuth } from "@/lib/auth/session";
import { getExportJobDownloadUrl } from "@/lib/api/endpoints";
import { AppLayout } from "@/pages/AppLayout";
import { DashboardPage } from "@/pages/DashboardPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { LoginPage } from "@/pages/login/LoginPage";
import { MembersPage } from "@/pages/members/MembersPage";
import { ProfileEditorPage } from "@/pages/profiles/ProfileEditorPage";
import { ProfilesPage } from "@/pages/profiles/ProfilesPage";
import { SettingsPage } from "@/pages/settings/SettingsPage";
import { UploadPage } from "@/pages/upload/UploadPage";
import { ImportPage } from "@/pages/workbooks/ImportPage";
import { WorkbooksPage } from "@/pages/workbooks/WorkbooksPage";
import { WorkbookPage } from "@/pages/workbooks/detail/WorkbookPage";
import { SheetPage } from "@/pages/workbooks/sheet/SheetPage";

/** Target of the "export ready" email link: hand off to the file download. */
function ExportDownloadRedirect() {
  const { jobId = "" } = useParams();
  window.location.replace(getExportJobDownloadUrl(jobId));
  return null;
}

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "upload", element: <UploadPage /> },
      { path: "workbooks", element: <WorkbooksPage /> },
      { path: "workbooks/import", element: <ImportPage /> },
      { path: "workbooks/:id", element: <WorkbookPage /> },
      { path: "workbooks/:id/sheets/:sheet", element: <SheetPage /> },
      { path: "profiles", element: <ProfilesPage /> },
      { path: "profiles/:id", element: <ProfileEditorPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "members", element: <MembersPage /> },
      { path: "exports/:jobId", element: <ExportDownloadRedirect /> },
      // The old standalone user-admin page lives under Settings → Access now.
      { path: "admin/users", element: <Navigate to="/settings?tab=access" replace /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
